import { CaseService } from '../../../../support/services/case.service';
import { CaseManager } from '../../../../support/services/case-data.service';
import { Injectable } from '@angular/core';
import { SupportCase } from '../../../../support/support.interface';
import { tap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class SupportCaseService {
    constructor(
        private caseService: CaseService,
        private caseManager: CaseManager,
        private router: Router,
    ) {}

    createSubmitCase = (supportCase: Partial<SupportCase>): Observable<SupportCase> => {
        return this.caseService.saveCase(supportCase).pipe(
            tap((newSupportCase): void => {
                if (newSupportCase) {
                    this.caseManager.addCase(newSupportCase);

                    this.router.navigate(['/support/cases'], { queryParams: { caseId: newSupportCase.id } });
                }
            }),
        );
    };
}
